import React from "react";

import { makeObservable, observable, action } from "mobx";

import { searchNormalMsgByOpenPortal } from "utils/api";

// 订阅管理store
export default class TrafficPermissionStore {
  list = null;
  total = 0;
  tableData = [];
  isLoading = false

  constructor() {
    makeObservable(this, {
      list: observable,
      total: observable,
      tableData: observable,
      isLoading:observable,
      searchNormalMsgByOpenPortal: action,
    });
  }

  async searchNormalMsgByOpenPortal(data) {
    this.isLoading = true
    const res = await searchNormalMsgByOpenPortal(data);
    if(res.data.result && res.data.result.items) {
      this.list = [...res.data.result.items];
      this.total = res.data.result.pageItemTotal;
      this.tableData = this.list.map((item, index) => {
        return {
          createtime: item.createTime,
          normalType: item.msgId,
          type: item.showType,
          key: index,
          body: (
            <div className="subscribe-table-item">
              <div
                className="content"
                dangerouslySetInnerHTML={{ __html: item.context }}
              ></div>
            </div>
          ),
          time: item.updateTime,
          status: item.processState === 1 ? <span style={{color: '#0083FF'}}>待处理</span> : <span>已处理</span>,
        };
      });
      this.isLoading = false
    } else {
      this.list = [];
      this.total = 0;
      this.tableData = [];
      this.isLoading = false
    }
  }
}
